import { Record } from 'immutable';

import Incentives from './Incentives.js';
import PurchaseTerm from './PurchaseTerm.js';

export default Record({
    bestIncentives: new Incentives(),
    leaseOrFinanceBonus: 0,
    cash: {
        cashSalePrice: 0,
        incentives: [],
    },
    lease: new PurchaseTerm(),
    finance: new PurchaseTerm(),
});



// WEBPACK FOOTER //
// ./src/models/EnhancedPricing.js